import sportsApi from '../../utils/sportsApi';

const fetchSponsors = async ({
    clientId,
    rightsholderId,
    useRightsholderAttribution = false,
}) => {
    const endPoint = `/clients/${clientId}/rightsholders/${rightsholderId}/sponsors`;
    const sponsors = await sportsApi
        .url(endPoint)
        .query(
            useRightsholderAttribution
                ? { useRightsholderAttribution: true }
                : {},
        )
        .get()
        .json();

    if (!Array.isArray(sponsors)) {
        return [];
    }

    return sponsors
        .map(s => ({
            value: s.id,
            name: s.name,
        }))
        .sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
};

export default fetchSponsors;
